import React, { FC, memo, useImperativeHandle } from 'react';
import { useRequest } from 'ahooks';
import { Icon, Space } from 'udesk-ui';
import { getAsrFilterConfigSamplingLimit } from 'src/api/asr-filter-config/samplingLimit';
import UdeskLocales from 'UdeskLocales';

interface TemplateProps {
    forwardRef?: React.Ref<{
        refresh: () => void;
    }>;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { forwardRef } = props;

    const { data, loading, refresh } = useRequest(getAsrFilterConfigSamplingLimit);

    useImperativeHandle(forwardRef, () => {
        return {
            refresh,
        };
    });

    return (
        <div style={{ marginBottom: 8 }}>
            {loading ? (
                <Icon antdIcon type="LoadingOutlined" />
            ) : data?.data?.checkResult ? (
                <Space style={{ color: '#52c41a' }}>
                    <Icon antdIcon type="InfoCircleOutlined" />
                    <div>{/* 未达到抽取上限 */}{UdeskLocales['current'].pages.speechRecognition.components.aSRFilterStatus.index.drawLimitNotReached}</div>
                </Space>
            ) : (
                <Space style={{ color: '#ff4d4f' }}>
                    <Icon antdIcon type="InfoCircleOutlined" />
                    <div>{/* 已达到抽取上限 */}{UdeskLocales['current'].pages.speechRecognition.components.aSRFilterStatus.index.drawLimitReached}</div>
                </Space>
            )}
        </div>
    );
});

export default Template;
